import React, { Fragment } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ItemStatusIcons = ({
  banned,
  images,
  isRestricted,
  potentiallyBanned,
  unpublished,
  lotID,
}) => (
  <Fragment>
    {unpublished && (
    <Fragment>
      <FontAwesomeIcon icon="upload" className="item-icon color-danger ml-2" id={`unpubTooltip-${lotID}`} />
      <UncontrolledTooltip
        placement="top"
            // (bnikom) allows the tooltip to overflow onto the table headers instead
            // of being placed bottom existing issue:
            // https://github.com/reactstrap/reactstrap/issues/1118
        modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
        className="item-status"
        target={`unpubTooltip-${lotID}`}
      >
        Unpublished
      </UncontrolledTooltip>
    </Fragment>
    )}
    {banned
        && (
        <Fragment>
          <FontAwesomeIcon icon="ban" className="item-icon color-danger ml-2" id={`banTooltip-${lotID}`} />
          <UncontrolledTooltip
            placement="top"
            modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
            className="item-status"
            target={`banTooltip-${lotID}`}
          >
            Banned
          </UncontrolledTooltip>
        </Fragment>
        )}
    {potentiallyBanned
        && (
        <Fragment>
          <FontAwesomeIcon icon="ban" className="item-icon color-warning ml-2" id={`potenBanTooltip-${lotID}`} />
          <UncontrolledTooltip
            placement="top"
            modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
            className="item-status"
            target={`potenBanTooltip-${lotID}`}
          >
            Potentially Banned
          </UncontrolledTooltip>
        </Fragment>
        )}
    {isRestricted
        && (
        <Fragment>
          <FontAwesomeIcon icon="credit-card" className="item-icon color-warning ml-2" id={`payRestTooltip-${lotID}`} />
          <UncontrolledTooltip
            placement="top"
            modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
            className="item-status"
            target={`payRestTooltip-${lotID}`}
          >
            Payment Restricted
          </UncontrolledTooltip>
        </Fragment>
        )}
    {images <= 0
        && (
        <Fragment>
          <FontAwesomeIcon icon="image" className="item-icon color-danger ml-2" id={`noImgTooltip-${lotID}`} />
          <UncontrolledTooltip
            placement="top"
            modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
            className="item-status"
            target={`noImgTooltip-${lotID}`}
          >
            Item Without Images
          </UncontrolledTooltip>
        </Fragment>
        )}
    {!unpublished
        && (
        <Fragment>
          <FontAwesomeIcon icon="check-circle" className="item-icon color-success ml-2" id={`pubTooltip-${lotID}`} />
          <UncontrolledTooltip
            placement="top"
            modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
            className="item-status"
            target={`pubTooltip-${lotID}`}
          >
            Published
          </UncontrolledTooltip>
        </Fragment>
        )}
  </Fragment>
);

export default ItemStatusIcons;
